function SectionHeader({
  title,
  description,
  align = 'center',
}: {
  title: string;
  description: string;
  // eslint-disable-next-line react/require-default-props
  align?: 'left' | 'right' | 'center';
}) {
  return (
    <div className={`text-${align} py-5`}>
      <h2 className="text-xl font-medium font-primary">{title}</h2>
      <p className="text-muted-foreground mt-4 font-normal text-sm">
        {description}
      </p>
    </div>
  );
}

export default SectionHeader;
